import axios, { AxiosResponse } from 'axios';

const url = '/services/isnaportal/open-api';

export const getAutomatedDictionaries = (): Promise<AxiosResponse> => {
    return axios.get(`${url}/dictionary-list`, {
        params: { source: 'IBD' },
    });
};

export const getUploadedDictionaries = (): Promise<AxiosResponse> => {
    return axios.get(`${url}/uploaded-dictionary-list`, { params: { latest: true } });
};
